export default __webpack_public_path__ + "static/media/parrot.8954bebb.gif";